import React, { useContext } from "react";
import { PanelLeftClose, PanelLeftOpen } from "lucide-react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import CustomizerContext from "../../_helper/Customizer";
import { Image } from "../../AbstractElements";

// Sidebar başlığı: logo + collapse/pin toggle (logonun SAĞINDA — sahip feedback'i).
// Rail'de logo-wrapper gizli (icon-logo görünür); hover-peek/pinned'de bu başlık
// + pin görünür. Pin → toggleIcon (rail ↔ pinned), ThemeProvider'da persist.
const SidebarLogo = () => {
  const { toggleSidebar, toggleIcon } = useContext(CustomizerContext);
  const { t } = useTranslation();

  const openCloseSidebar = () => toggleSidebar(!toggleIcon);

  return (
    <div className="logo-wrapper">
      <Link to={"/"}>
        <Image
          attrImage={{
            className: "img-fluid d-inline",
            src: `/logo5122.png`,
            alt: "",
          }}
        />
      </Link>
      <button
        type="button"
        className="sidebar-pin-toggle"
        onClick={openCloseSidebar}
        title={toggleIcon ? t("Pin sidebar") : t("Collapse sidebar")}
        aria-label={toggleIcon ? t("Pin sidebar") : t("Collapse sidebar")}
      >
        {toggleIcon ? <PanelLeftOpen size={18} /> : <PanelLeftClose size={18} />}
      </button>
    </div>
  );
};

export default SidebarLogo;
